import React from "react";
import { MessageCircle } from "lucide-react";
import { useIsConciergePage } from "@/utils/hooks/useIsConciergePage";
import { useConciergeWidget } from "@/utils/hooks/useConciergeWidget";
import { useIsConciergeEnabled } from "@brandclub/common-ui";
import { useAppSelector } from "@/redux/hooks";

export const ConciergeFloatingButton: React.FC = () => {
  const isConciergePage = useIsConciergePage();
  const { toggle, isOpen } = useConciergeWidget();
  const userProfile = useAppSelector(({ userProfile }) => userProfile);
  const isConciergeSplitEnabled = useIsConciergeEnabled({
    email: userProfile?.email,
  });

  // Hide button when on the concierge page or when widget is open or when not in concierge split
  if (isConciergePage || isOpen || !isConciergeSplitEnabled) {
    return null;
  }

  return (
    <button
      onClick={toggle}
      className="tw:fixed tw:bottom-6 tw:right-6 tw:w-[60px] tw:h-[60px] tw:bg-[#1e293b] tw:rounded-full tw:shadow-2xl tw:cursor-pointer tw:flex tw:items-center tw:justify-center tw:z-[1400] tw:transition-transform tw:duration-200 hover:tw:scale-110"
      aria-label="Open Concierge"
    >
      <MessageCircle className="tw:w-6 tw:h-6 tw:text-white" />
    </button>
  );
};
